import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CompanySettingsService {

  private baseurl = "";
  private apiroute = "";
  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  // GetClientSettings(name){
  //   console.log({method: 'Get_ClientSettingsByName', name: name});
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettingsByName', name: name})
  // }

  // GetCompanyTypes(){
  //   return this.http.post<any>(this.baseurl + '/public/GetOrganizationType', {})
  // }

  // GetCubePlans(){
  //   return this.http.post<any>(this.baseurl + '/public/GetCubePlans', {})
  // }

  // UpdateCreditCardInfo(obj: any){
  //   return this.http.post<any>(this.baseurl + this.apiroute, obj )
  // }

  // GetCreditCardInfo(myid: number){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByID', id: myid } )
  // }

  // GetCreditCardList(){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByCustomerID' } )
  // }

  GetStripeCustomerList(){
    return this.http.post<any>(this.baseurl + '/public/getStripeCustomer', {})
  }

  GetStripeCustomerId(){
    return this.http.post<any>(this.baseurl + '/public/getStripeCustomerId', {})
  }

  getPaymentMethodById(obj: any){
    return this.http.post<any>(this.baseurl + '/public/getPaymentMethodById', obj )
  }

  // UpdateCreditCardInfoStripe(obj: any){
  //   return this.http.post<any>(this.baseurl + '/public/UpdateCreditCardInfoStripe', obj)
  // }

  getCustomerBilling(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CustomerBilliable' } )
  }

  // SaveNewExternalUser(newuser: any){
  //   return this.http.post<any>(this.baseurl + '/public/SaveNewExternalUser', newuser)
  // }

  // UpdateClientSettings(name, description, value){
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettings', name: name, description: description, value: value})
  // }

  // UpdateEstimateDefault(name, value){
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'UpdateEstimateDefaulvaluesCE',  name: name, value: value})
  // }

  // UpdateClientSettingsDescription(name, description){
  //   console.log({method: 'Update_ClientSettingsDescription', name: name, description: description})
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettingsDescription', name: name, description: description})
  // }

  // GetImgLogoPath(){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_ImgCompanyLogoPath' })
  // }

  // SaveDocument(filestring){
  //   return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: filestring, doctype: 'logo', id: 1 })
  // }

  // GetDocument(filepath): Observable<any> {
  //   return this.http.post(this.baseurl + '/DownloadFile/Download', { filename: filepath });
  // }

  // GetUtility(method) {
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: method })
  // }

  // UpdateUtility(obj){
  //   console.log('Update ', obj);
  //   return this.http.post<any>(this.baseurl + this.apiroute, obj)
  // }


  GetClientSettings(name){
    console.log({method: 'Get_ClientSettingsByName', name: name});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettingsByName', name: name})
  }

  GetClientSettingsAll(){
    console.log({method: 'Get_ClientSettingsByName'});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettings '})
  }

  GetCompanyTypes(){
    return this.http.post<any>(this.baseurl + '/public/GetOrganizationType', {})
  }

  GetCubePlans(){
    return this.http.post<any>(this.baseurl + '/public/GetCubePlans', {})
  }

  UpdateCreditCardInfo(obj: any){
    return this.http.post<any>(this.baseurl + this.apiroute, obj )
  }

  UpdateCreditCardInfoTemp(obj: any){
    return this.http.post<any>(this.baseurl + '/public/UpdateCreditCardInfoTemp', obj)
  }

  GetCreditCardInfo(myid: number){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByID', id: myid } )
  }

  GetCreditCardList(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByCustomerID' } )
  }

  UpdateCreditCardInfoStripe(obj: any){
    return this.http.post<any>(this.baseurl + '/public/UpdateCreditCardInfoStripe', obj)
  }

  updateCreditCardInfoStripeTemp(obj: any){
    return this.http.post<any>(this.baseurl + '/public/updateCreditCardInfoStripeTemp', obj)
  }

  SaveNewExternalUser(newuser: any){
    return this.http.post<any>(this.baseurl + '/public/SaveNewExternalUser', newuser)
  }

  UpdateClientSettings(name, description, value){
    // console.log({method: 'Update_ClientSettings', name: name, description: description, value: 11});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettings', name: name, description: description, value: value})
  }

  UpdateEstimateDefault(name, value){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'UpdateEstimateDefaulvaluesCE',  name: name, value: value})
  }

  UpdateClientSettingsDescription(name, description){
    console.log({method: 'Update_ClientSettingsDescription', name: name, description: description})
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettingsDescription', name: name, description: description})
  }

  GetImgLogoPath(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_ImgCompanyLogoPath' })
  }

  Get_CustomerBillingHistory(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CustomerBillingHistory' })
  }

  sendPaymentNotification(lparameterxml: string){
    return this.http.post<any>(this.baseurl + '/Notifications/NotificationGenericTemplate', { service: 'GetPaymentReminderLetterEmail', parameterxml: lparameterxml } )
  }

  createPayment(obj: any){
    return this.http.post<any>(this.baseurl + '/public/createCharge', obj )
  }

  SaveDocument(filestring){
    return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: filestring, doctype: 'logo', id: 1 })
  }

  GetDocument(filepath): Observable<any> {
    return this.http.post(this.baseurl + '/DownloadFile/Download', { filename: filepath });
  }

  GetUtility(method) {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: method })
  }

  UpdateUtility(obj){
    console.log('Update ', obj);
    return this.http.post<any>(this.baseurl + this.apiroute, obj)
  }
}
